import { useViewControlsStore } from "@/Stores/viewControls";
import { computed } from "vue";

export function useViewControls(storeKey) {
    const viewControlsStore = useViewControlsStore();

    const loading = computed(() => {
        if (viewControlsStore[storeKey]) {
            return viewControlsStore[storeKey].loading;
        }

        return true;
    });

    const handleUpdateLoading = (value) => {
        if (!viewControlsStore[storeKey]) {
            console.error(
                "The specified store key is not present in the tasks view store."
            );
        }

        viewControlsStore[storeKey].loading = value;
    };

    return {
        handleUpdateLoading,
        loading,
    };
}
